class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverTimeout = null;
    
    // Only add hover functionality on desktop
    if (window.innerWidth >= 990) {
      this.setupHoverBehavior();
    }
    
    // Listen for window resize to toggle hover behavior
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        this.setupHoverBehavior();
      } else {
        this.removeHoverBehavior();
      }
    });
  }

  setupHoverBehavior() {
    if (this.hoverEnabled) return; // Already enabled
    this.hoverEnabled = true;
    
    // Prevent default click behavior on summary
    this.summary.addEventListener('click', this.preventClick.bind(this));
    
    // Add hover listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }
  
  removeHoverBehavior() {
    if (!this.hoverEnabled) return; // Already disabled
    this.hoverEnabled = false;
    
    // Remove click prevention
    this.summary.removeEventListener('click', this.preventClick.bind(this));
    
    // Remove hover listeners
    this.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.removeEventListener('mouseleave', this.onMouseLeave.bind(this));
  }
  
  preventClick(event) {
    if (this.hoverEnabled) {
      event.preventDefault();
    }
  }
  
  onMouseEnter() {
    if (!this.hoverEnabled) return;
    
    // Clear any pending close timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    
    // Open the menu
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }
  
  onMouseLeave() {
    if (!this.hoverEnabled) return;
    
    // Add a small delay before closing to prevent flickering
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
